"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DynoEditorFullDemo = _interopRequireDefault(require("./DynoEditorFullDemo"));

var _default = _react.default.createClass({
  displayName: "DynoPublishPanel",
  propTypes: {
    updateDyno: _react.default.PropTypes.func.isRequired,
    dyno: _react.default.PropTypes.object.isRequired,
    domain: _react.default.PropTypes.string.isRequired
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowPublishPanel." + suffix;
  },
  render: function render() {
    var _this$props = this.props,
        dyno = _this$props.dyno,
        domain = _this$props.domain;
    return _react.default.createElement("div", {
      className: "dyno-editor-publish"
    }, _react.default.createElement(_DynoEditorFullDemo.default, {
      updateDyno: this.props.updateDyno,
      dyno: dyno,
      domain: domain
    }));
  }
});

exports.default = _default;
module.exports = exports.default;